module.exports = __webpack_public_path__ + "img/center.d682edcd.webp";